//Custo css import
import './style.css'

//Boostrap import
import Form from 'react-bootstrap/Form';
import { UserPlus } from 'lucide-react';

//React import
import { useState, useEffect } from 'react';

//Controller import
import ModalBtn from '../../molecules/modalButton/view';
import ButtonLoading from '../../atoms/buttonLoading/view';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { createUser } from '../../../usecases/user-operations-usecase'; // Assuming this usecase exists
import Select from 'react-select'; // For role selection

function NewUser({ id }) {

    const [formData, setFormData] = useState(undefined);
    const [formErrors, setFormErrors] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);

    const roleOptions = [
        { value: 2, label: 'Admin' },
        { value: 4, label: 'Contador' },
    ];

    useEffect(() => {
        validateForm();
    }, [formData]);

    function validateForm() {
        if (!formData) {
            setIsFormValid(false);
            return;
        }

        const errors = {};
        if (!formData.name) errors.name = "El nombre es requerido.";
        if (!formData.email) errors.email = "El email es requerido.";
        if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = "El email no es válido.";
        if (formData.password && formData.password.length < 6) errors.password = "La contraseña debe tener al menos 6 caracteres.";
        if (!formData.phone) errors.phone = "El teléfono es requerido.";
        if (!formData.document) errors.document = "El documento es requerido.";
        if (!formData.documentType) errors.documentType = "El tipo de documento es requerido.";
        if (!formData.address) errors.address = "La dirección es requerida.";
        if (!formData.companyName) errors.companyName = "El nombre de la compañía es requerido.";
        if (formData.terms === undefined || formData.terms === null) errors.terms = "Debe aceptar los términos y condiciones.";
        if (!formData.roleId) errors.roleId = "El rol es requerido.";


        setFormErrors(errors);
        setIsFormValid(Object.keys(errors).length === 0);
    }

    function handleChange(event) {
        const { name, value, type, checked } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    }

    function handleRoleChange(selectedOption) {
        setFormData((prevState) => ({
            ...prevState,
            roleId: selectedOption ? selectedOption.value : null
        }));
    }

    function handleOpen() {
        setFormData({
            name: "",
            email: "",
            phone: "",
            document: "",
            documentType: null,
            address: "",
            companyName: "",
            terms: false,
            roleId: null,
        });
        setFormErrors({});
        setIsFormValid(false);
    }

    function onSubmit() {
        if (!isFormValid) {
            dispatchCustomEvent("popup", { message: "Por favor, completa todos los campos requeridos.", type: "error" });
            return;
        }

        createUser(formData).then((res) => {
            dispatchCustomEvent("close-newUser-" + id + "-modal", []);
            dispatchCustomEvent("popup", { message: "Usuario creado correctamente", type: "success" });
            dispatchCustomEvent("reload-users", res); // Assuming an event to reload user list
            dispatchCustomEvent("loading-btn", null);
            dispatchCustomEvent("close-newUser-" + id + "-modal", []);
        }).catch((error) => {
            dispatchCustomEvent("popup", { message: error.response?.data?.message || "Error al crear usuario.", type: "error" });
            dispatchCustomEvent("loading-btn", null);
        });
    }

    return (
        <ModalBtn
            id={"newUser-" + id}
            title="Nuevo Usuario"
            icon={<UserPlus size={20} />}
            onClick={handleOpen}
        >
            <Form id="user-form" action="javascript:void(0);">
                <Form.Group controlId="formUserName">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                        type="text"
                        name="name"
                        value={formData?.name || ""}
                        onChange={handleChange}
                        isInvalid={!!formErrors.name}
                    />
                    <Form.Control.Feedback type="invalid">{formErrors.name}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formUserEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        type="email"
                        name="email"
                        value={formData?.email || ""}
                        onChange={handleChange}
                        isInvalid={!!formErrors.email}
                    />
                    <Form.Control.Feedback type="invalid">{formErrors.email}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formUserPhone">
                    <Form.Label>Teléfono</Form.Label>
                    <Form.Control
                        type="text"
                        name="phone"
                        value={formData?.phone || ""}
                        onChange={handleChange}
                        isInvalid={!!formErrors.phone}
                    />
                    <Form.Control.Feedback type="invalid">{formErrors.phone}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formUserDocument">
                    <Form.Label>Documento</Form.Label>
                    <Form.Control
                        type="text"
                        name="document"
                        value={formData?.document || ""}
                        onChange={handleChange}
                        isInvalid={!!formErrors.document}
                    />
                    <Form.Control.Feedback type="invalid">{formErrors.document}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formUserDocumentType">
                    <Form.Label>Tipo de Documento</Form.Label>
                    <Form.Control
                        as="select"
                        name="documentType"
                        value={formData?.documentType || ""}
                        onChange={handleChange}
                        isInvalid={!!formErrors.documentType}
                    >
                        <option value="">Selecciona...</option>
                        <option value={1}>CC</option>
                        <option value={2}>NIT</option>
                        {/* Add more document types as needed */}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">{formErrors.documentType}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formUserAddress">
                    <Form.Label>Dirección</Form.Label>
                    <Form.Control
                        type="text"
                        name="address"
                        value={formData?.address || ""}
                        onChange={handleChange}
                        isInvalid={!!formErrors.address}
                    />
                    <Form.Control.Feedback type="invalid">{formErrors.address}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formUserCompanyName">
                    <Form.Label>Nombre de la Compañía</Form.Label>
                    <Form.Control
                        type="text"
                        name="companyName"
                        value={formData?.companyName || ""}
                        onChange={handleChange}
                        isInvalid={!!formErrors.companyName}
                    />
                    <Form.Control.Feedback type="invalid">{formErrors.companyName}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formUserRole">
                    <Form.Label>Rol</Form.Label>
                    <Select
                        options={roleOptions}
                        onChange={handleRoleChange}
                        value={roleOptions.find(option => option.value === formData?.roleId)}
                        isInvalid={!!formErrors.roleId}
                    />
                    {formErrors.roleId && <div className="invalid-feedback d-block">{formErrors.roleId}</div>}
                </Form.Group>
                <Form.Group controlId="formUserTerms">
                    <Form.Check
                        type="checkbox"
                        label="Acepto los términos y condiciones"
                        name="terms"
                        checked={formData?.terms || false}
                        onChange={handleChange}
                        isInvalid={!!formErrors.terms}
                    />
                    <Form.Control.Feedback type="invalid">{formErrors.terms}</Form.Control.Feedback>
                </Form.Group>

                <br />

                <ButtonLoading
                    id="user-create"
                    title={"Crear usuario"}
                    onClick={onSubmit}
                    disabled={!isFormValid}
                />
            </Form>
        </ModalBtn>
    )
}

export default NewUser
